import React from 'react';
import {BaseMixin, ElementaryMixin, ContentMixin} from '../common/common.js';
import Span from './span.js';

import './ignore-inner-html.less';

export const IgnoreInnerHtml = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ContentMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.IgnoreInnerHTML',
    classNames: {
      main: 'uu5-bricks-ignore-inner-html'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getMainProps: function () {
    var mainProps = this.getMainPropsToPass(
      [
        'UU5_Common_BaseMixin',
        'UU5_Common_ElementaryMixin',
        'UU5_Common_ContentMixin'
      ]
    );

    mainProps.id = this.getId() + '-span';
    mainProps.ignoreInnerHTML = true;

    return mainProps;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      <Span {...this._getMainProps()}>
        {React.Children.toArray(this.props.children)}
      </Span>
    );
  }
  //@@viewOff:render
});

export default IgnoreInnerHtml;


// WEBPACK FOOTER //
// ./bricks/ignore-inner-html.js